'use strict';
/* eslint indent: 4 */
// Private helper class

var _classCallCheck = require("C:\\Projects\\Sledgehammer\\src\\Frontends\\WebApps\\Spintr.Site\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Sledgehammer\\src\\Frontends\\WebApps\\Spintr.Site\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var SubRange = /*#__PURE__*/function () {
  function SubRange(low, high) {
    _classCallCheck(this, SubRange);

    this.low = low;
    this.high = high;
    this.length = 1 + high - low;
  }

  _createClass(SubRange, [{
    key: "overlaps",
    value: function overlaps(range) {
      return !(this.high < range.low || this.low > range.high);
    }
  }, {
    key: "touches",
    value: function touches(range) {
      return !(this.high + 1 < range.low || this.low - 1 > range.high);
    } // Returns inclusive combination of SubRanges as a SubRange.

  }, {
    key: "add",
    value: function add(range) {
      return new SubRange(Math.min(this.low, range.low), Math.max(this.high, range.high));
    } // Returns subtraction of SubRanges as an array of SubRanges.
    // (There's a case where subtraction divides it in 2)

  }, {
    key: "subtract",
    value: function subtract(range) {
      if (range.low <= this.low && range.high >= this.high) {
        return [];
      } else if (range.low > this.low && range.high < this.high) {
        return [new SubRange(this.low, range.low - 1), new SubRange(range.high + 1, this.high)];
      } else if (range.low <= this.low) {
        return [new SubRange(range.high + 1, this.high)];
      } else {
        return [new SubRange(this.low, range.low - 1)];
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.low == this.high ? this.low.toString() : this.low + '-' + this.high;
    }
  }]);

  return SubRange;
}();

var DRange = /*#__PURE__*/function () {
  function DRange(a, b) {
    _classCallCheck(this, DRange);

    this.ranges = [];
    this.length = 0;
    if (a != null) this.add(a, b);
  }

  _createClass(DRange, [{
    key: "_update_length",
    value: function _update_length() {
      this.length = this.ranges.reduce(function (previous, range) {
        return previous + range.length;
      }, 0);
    }
  }, {
    key: "add",
    value: function add(a, b) {
      var _this = this;

      var _add = function _add(subrange) {
        var i = 0;

        while (i < _this.ranges.length && !subrange.touches(_this.ranges[i])) {
          i++;
        }

        var newRanges = _this.ranges.slice(0, i);

        while (i < _this.ranges.length && subrange.touches(_this.ranges[i])) {
          subrange = subrange.add(_this.ranges[i]);
          i++;
        }

        newRanges.push(subrange);
        _this.ranges = newRanges.concat(_this.ranges.slice(i));

        _this._update_length();
      };

      if (a instanceof DRange) {
        a.ranges.forEach(_add);
      } else {
        if (b == null) b = a;

        _add(new SubRange(a, b));
      }

      return this;
    }
  }, {
    key: "subtract",
    value: function subtract(a, b) {
      var _this2 = this;

      var _subtract = function _subtract(subrange) {
        var i = 0;

        while (i < _this2.ranges.length && !subrange.overlaps(_this2.ranges[i])) {
          i++;
        }

        var newRanges = _this2.ranges.slice(0, i);

        while (i < _this2.ranges.length && subrange.overlaps(_this2.ranges[i])) {
          newRanges = newRanges.concat(_this2.ranges[i].subtract(subrange));
          i++;
        }

        _this2.ranges = newRanges.concat(_this2.ranges.slice(i));

        _this2._update_length();
      };

      if (a instanceof DRange) {
        a.ranges.forEach(_subtract);
      } else {
        if (b == null) b = a;

        _subtract(new SubRange(a, b));
      }

      return this;
    }
  }, {
    key: "intersect",
    value: function intersect(a, b) {
      var _this3 = this;

      var newRanges = [];

      var _intersect = function _intersect(subrange) {
        var i = 0;

        while (i < _this3.ranges.length && !subrange.overlaps(_this3.ranges[i])) {
          i++;
        }

        while (i < _this3.ranges.length && subrange.overlaps(_this3.ranges[i])) {
          var low = Math.max(_this3.ranges[i].low, subrange.low);
          var high = Math.min(_this3.ranges[i].high, subrange.high);
          newRanges.push(new SubRange(low, high));
          i++;
        }
      };

      if (a instanceof DRange) {
        a.ranges.forEach(_intersect);
      } else {
        if (b == null) b = a;

        _intersect(new SubRange(a, b));
      }

      this.ranges = newRanges;

      this._update_length();

      return this;
    }
  }, {
    key: "index",
    value: function index(_index) {
      var i = 0;

      while (i < this.ranges.length && this.ranges[i].length <= _index) {
        _index -= this.ranges[i].length;
        i++;
      }

      return this.ranges[i].low + _index;
    }
  }, {
    key: "toString",
    value: function toString() {
      return '[ ' + this.ranges.join(', ') + ' ]';
    }
  }, {
    key: "clone",
    value: function clone() {
      return new DRange(this);
    }
  }, {
    key: "numbers",
    value: function numbers() {
      return this.ranges.reduce(function (result, subrange) {
        var i = subrange.low;

        while (i <= subrange.high) {
          result.push(i);
          i++;
        }

        return result;
      }, []);
    }
  }, {
    key: "subranges",
    value: function subranges() {
      return this.ranges.map(function (subrange) {
        return {
          low: subrange.low,
          high: subrange.high,
          length: 1 + subrange.high - subrange.low
        };
      });
    }
  }]);

  return DRange;
}();

module.exports = DRange;